import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Quiz.module.css";
import DarkModeToggle from "./DarkModeToggle";
import gamesData from "./gamesData";
import { useUser } from "../context/UserAttrContext";

const QuizPage = () => {
    const navigate = useNavigate();
    const { updateAttributes, user } = useUser();
    const userToken = sessionStorage.getItem("token");
    const userId = sessionStorage.getItem("user");
    const [activeCard, setActiveCard] = useState("start");
    const [selectedGames, setSelectedGames] = useState([]);

    useEffect(() => {
        if (!userToken) {
            navigate("/");
        } else if (activeCard === "start") {
            fetch(process.env.REACT_APP_API_PATH + "/users/" + userId, {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + userToken,
                },
              })
                .then((res) => res.json())
                .then((result) => {
                  if (result) {
                    if (result.attributes?.quizCompleted) {
                      navigate("/");
                    }
                }
            });
        }
    }, [activeCard, navigate, user.quizCompleted, userId, userToken]);

    const toggleGameSelection = (gameId) => {
        setSelectedGames((prevSelected) => {
            if (prevSelected.includes(gameId)) {
                return prevSelected.filter((id) => id !== gameId);
            } else if (prevSelected.length < 5) {
                return [...prevSelected, gameId];
            }
            return prevSelected;
        });
    };

    const handleNext = async () => {
        try {
            await updateAttributes({ favoriteGames: selectedGames, quizCompleted: true });

            const token = sessionStorage.getItem("token");
            const userId = sessionStorage.getItem("user");

            // Add user to groups for selected games
            for (const gameId of selectedGames) {
                const game = Object.values(gamesData).find((g) => g.id === gameId);
                if (game) {
                    try {
                        await fetch(`${process.env.REACT_APP_API_PATH}/group-members`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${token}`,
                            },
                            body: JSON.stringify({
                                userID: userId,
                                groupID: game.groupId,
                            }),
                        });
                    } catch (err) {
                        console.error(`Failed to add to group for game ${gameId}:`, err);
                    }
                }
            }

            setActiveCard("finish");
        } catch (error) {
            console.error("Failed to update favorite games:", error);
        }
    };

    return (
        <div className={styles.quizPage}>
            {activeCard === "start" && (
                <div className={styles.card}>
                    <h1>Let's get you started</h1>
                    <div className={styles.buttons}>
                        <button className={styles.greenButton} onClick={() => setActiveCard("favoriteGames")}>Go</button>
                    </div>
                </div>
            )}
            {activeCard === "favoriteGames" && (
                <div className={styles.card}>
                    <h1>What are your favorite games?</h1>
                    <p className={styles.selectionLimit}>Select up to 5 games</p>
                    <div className={styles.games}>
                        {Object.entries(gamesData).map(([name, game]) => (
                            <label key={game.id} className={styles.gameFrame}>
                                <img src={game.carouselImage} alt={name} className={styles.gameImage} />
                                <input
                                    type="checkbox"
                                    className={styles.gameCheckbox}
                                    checked={selectedGames.includes(game.id)}
                                    onChange={() => toggleGameSelection(game.id)}
                                    disabled={!selectedGames.includes(game.id) && selectedGames.length >= 5}
                                />
                            </label>
                        ))}
                    </div>
                    <div className={styles.buttons}>
                        <button className={styles.blueButton} onClick={() => setActiveCard("start")}>Back</button>
                        <button className={styles.greenButton} onClick={handleNext}>Next</button>
                    </div>
                </div>
            )}
            {activeCard === "finish" && (
                <div className={styles.card}>
                    <h1>Welcome</h1>
                    <div className={styles.buttons}>
                        <button className={styles.blueButton} onClick={() => setActiveCard("favoriteGames")}>Back</button>
                        <button className={styles.greenButton} onClick={() => navigate("/")}>Go</button>
                    </div>
                </div>
            )}
            <DarkModeToggle />
        </div>
    );
};

export default QuizPage;
